// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__DS0RX","scrolled":"Navbar_scrolled__8DEci","logo":"Navbar_logo__jA5Pb","links":"Navbar_links__GNnVc","link":"Navbar_link__61lqP","cta":"Navbar_cta__urCAZ"};